import { defaultOptions as e } from "./i18n-config.mjs";
import { initReactI18next as t } from "react-i18next";
//#region src/translations/i18n-init-instance.ts
var n = (n, r) => (n.use(t).init({
	...e,
	...r
}), { i18n: n });
//#endregion
export { n as initI18nInstance };
